import {useState, useCallback, useEffect} from 'react'

const storageName = 'userData'

export const useAuth = () => {
    const [token, setToken] = useState(null)
    const [ready, setReady] = useState(false)
    const [userId, setUserId] = useState(null)
    const [empId, setEmpId] = useState(null)
    const [empName, setEmpName] = useState(null)
    const [empFilial, setEmpFilial] = useState(null)
    const [filialName, setFilialName] = useState(null)
    const [empInn, setEmpInn] = useState(null)

    const login = useCallback((jwtToken, id, empId, empName, empFilial, filialName, empInn) => {
        setToken(jwtToken)
        setUserId(id)
        setEmpId(empId)
        setEmpName(empName)
        setEmpFilial(empFilial)
        setFilialName(filialName)
        setEmpInn(empInn)
        setReady(true)

        localStorage.setItem(storageName, JSON.stringify({
            userId: id, token: jwtToken, empId: empId, empName: empName, empFilial: empFilial, filialName: filialName, empInn: empInn
        }))
    }, [])

    const logout = useCallback(() => {
        setToken(null)
        setUserId(null)
        setEmpId(null)
        setEmpName(null)
        setEmpFilial(null)
        setFilialName(null)
        setEmpInn(null)
        setReady(false)
        localStorage.removeItem(storageName)
    }, [])

    /* The filial title comes from a reference query, and that query is
       authorised — it can only run once login() has put the token into
       localStorage, where the request interceptor reads it. So the session is
       stored first and the title is written here, right after it arrives. */
    const saveFilialName = useCallback((name) => {
        setFilialName(name)
        try {
            const data = JSON.parse(localStorage.getItem(storageName))
            if (data) localStorage.setItem(storageName, JSON.stringify({...data, filialName: name}))
        } catch (e) {
            console.error("Auth update error: " + e)
        }
    }, [])

    useEffect(() => {
        try {
        const data = JSON.parse(localStorage.getItem(storageName))

        if (data && data.token) {
            login(data.token, data.userId, data.empId, data.empName, data.empFilial, data.filialName, data.empInn)
        }
        } catch (e) {
            console.error("Auth restore error: "+e)
        }
        setReady(true)
    }, [login])

    return {login, logout, saveFilialName, token, userId, ready, empId, empName, empFilial, filialName, empInn}
}